import { Component, OnInit } from "@angular/core";
import { AppService } from "../../../services/app.service";
import { ModalController } from "@ionic/angular";
import { CreditSaveTaxinvoiceComponent } from "../credit-save-taxinvoice/credit-save-taxinvoice.component";
import { ActivatedRoute, Router } from "@angular/router";
import { Storage } from "@ionic/storage";
import { _getStorage } from "src/app/utils/local-storage";
import { STORAGE } from "src/app/constant/storages";

@Component({
  selector: "app-credit-check-taxinvoice",
  templateUrl: "./credit-check-taxinvoice.component.html",
  styleUrls: ["./credit-check-taxinvoice.component.scss"],
})
export class CreditCheckTaxinvoiceComponent implements OnInit {
  creditNoteCheckData: any = {};

  buyerInfo: any;
  buyerType: string = "";
  branchType: string = "";

  fullname: string = "";
  buyer_cid: string = "";
  branch: string = "";

  product: any = [];
  res_rts: any;
  notaxid = false;
  nocardID = true;
  nocard = false;

  totalDiscount: string = "";
  totalAmtExdiscount: string = "";
  taxValue: string = "";
  totalNetSaleAmt: string = "";
  showbranch = false;
  Active = 3;
  isShowBranchNo = true;
  remark = "";
  showinputremark = false;
  constructor(
    public appService: AppService,
    public modalController: ModalController,
    public router: Router,
    public storage: Storage,
    public route: ActivatedRoute
  ) {}

  async ngOnInit() {
    this.appService.setActive(3);
  }
  ionViewDidEnter() {
    this.getStorageData();
    this.route.queryParams.subscribe((params) => {
      if (params.noName === "no_cn") {
        this.Active = Number(params.selectedIndex);
      } else {
        this.Active = 3;
      }
    });
  }

  data_ref_taxinvoice = "";
  async getStorageData() {
    this.appService.setActive(3);
    const resVerify = await _getStorage(STORAGE.verifyCreditNote);
    console.log("[getStorageData] verifyCreditNote res : ", resVerify);

    this.creditNoteCheckData = resVerify;
    console.log("[getStorageData] searchCreditNode resVerify : ", resVerify);

    this.creditNoteCheckData.ref_tax_invoice_no =
      this.creditNoteCheckData.ref_tax_invoice_no == "" ||
      this.creditNoteCheckData.ref_tax_invoice_no == null
        ? "N/A"
        : this.creditNoteCheckData.ref_tax_invoice_no;
    const res = await _getStorage(STORAGE.searchCreditNode);

    let isOldAbbTransaction = window.localStorage.isOldAbb;
    console.log(
      "🚀 ~ file: credit-check-taxinvoice.component.ts:80 ~ CreditCheckTaxinvoiceComponent ~ getStorageData ~ isOldAbbTransaction:",
      isOldAbbTransaction
    );

    if (isOldAbbTransaction === "Y") {
      console.log(" >>>>>>>>>>>>>>>>>> OLD TRANSACTION <<<<<<<<<<<<<<<<<<<");
      const tax_invoice_data = res.response.taxinvoice_list[0];
      console.log(
        "discount_on_returned_products ===>> ",
        tax_invoice_data.product.discount_on_returned_products
      );
      this.totalDiscount =
        tax_invoice_data.product.discount_on_returned_products
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      console.log(
        "product_value_including_tax ===>> ",
        tax_invoice_data.product.product_value_including_tax
      );
      this.totalAmtExdiscount =
        tax_invoice_data.product.product_value_including_tax
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      console.log("total_vat ===>> ", tax_invoice_data.product.total_vat);
      this.taxValue = tax_invoice_data.product.total_vat
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      console.log(
        "product_value_excluding_tax ===>> ",
        tax_invoice_data.product.product_value_excluding_tax
      );
      this.totalNetSaleAmt =
        tax_invoice_data.product.product_value_excluding_tax
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    } else {
      console.log(" >>>>>>>>>>>>>>>>>> NEW TRANSACTION <<<<<<<<<<<<<<<<<<<");
      console.log("new res.....", res);
      this.res_rts = await res.response.res_rts.salesTicket[0];
      console.log("[getStorageData] res_rts : ", this.res_rts);

      this.totalDiscount = this.res_rts.totalDiscount
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      this.totalAmtExdiscount = this.res_rts.totalSaleAmt
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      this.taxValue = this.res_rts.taxValue
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      this.totalNetSaleAmt = this.res_rts.totalNetSaleAmt
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }
    this.buyerInfo = this.creditNoteCheckData.buyer.name_info;
    this.buyerType = this.buyerInfo.type;
    if (this.buyerType === "0" || this.buyerType === "2") {
      this.showbranch = false;
      this.nocard = true;
    } else if (this.buyerType === "1") {
      this.showbranch = true;
      this.notaxid = true;
      this.nocard = true;
    } else if (this.buyerType === "3") {
      this.showbranch = false;
      this.notaxid = false;
      this.nocard = false;
    }
    this.branchType = this.buyerInfo.branch == "00000" ? "Y" : "N";
    this.fullname = this.buyerInfo.name;
    this.buyer_cid = this.buyerInfo.buyer_cid;
    this.branch = this.branchType == "N" ? this.buyerInfo.branch : "";
    this.product = this.creditNoteCheckData.product;
  }

  checkremark(e) {
    e.detail.checked == true
      ? (this.showinputremark = true)
      : (this.showinputremark = false);
  }
  goBackPage() {
    console.log(
      "window.localStorage.pageName====: ",
      window.localStorage.pageName
    );
    let pageName = window.localStorage.pageName;
    if (pageName == "CreditSelectTaxinvoiceComponent") {
      this.router.navigateByUrl("credit-note-tax-list");
      // this.router.navigate(["credit-note-tax-list"], {
      //   queryParams: { datalist: "datalist" },
      // });
    } else if (pageName == "CreditNoteTaxListComponent") {
      if (this.Active === 3) {
        this.router.navigateByUrl("credit-note-tax-list");
        // this.router.navigate(["/credit-note-tax-list"], {
        //   queryParams: { datalist: "datalist" },
        // });
      } else {
        this.router.navigate(["/credit-note-tax-list"], {
          queryParams: {
            noName: "no_cn",
            selectedIndex: "4",
            datalist: "datalist",
          },
        });
      }
    }
  }

  async presentModal() {
    this.appService.setActive(4);
    const modal = await this.modalController.create({
      component: CreditSaveTaxinvoiceComponent,
      cssClass: "my-custom-class",
      componentProps: {
        isShowBranchNo: this.isShowBranchNo,
        remark: this.remark,
      },
    });

    modal.onDidDismiss().then(async () => {});
    return await modal.present();
  }

  displayCID(buyerType: string) {
    let displayValue = "";
    switch (buyerType) {
      case "0":
        displayValue = "เลขที่บัตรประชาชน";
        break;
      case "1":
        displayValue = "เลขประจำตัวผู้เสียภาษี";
        break;
      case "2":
        displayValue = "เลขที่หนังสือเดินทาง";
        break;
      default:
        displayValue =
          "เลขที่บัตรประชาชน/เลขประจำตัวผู้เสียภาษี/เลขที่หนังสือเดินทาง";
        break;
    }

    return displayValue;
  }

  formatnumber(data) {
    // console.log('formatnumber : ', data)
    return data.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
  number(data: any) {
    let number = data;
    return String(number).padStart(13, "0");
  }

  receiptnumber(data: any) {
    let temp_no: any = data;
    if (temp_no) {
      temp_no = data.split("-");
      // console.log("temp_no", temp_no);
      return temp_no[0] + "-" + temp_no[1].padStart(6, "0");
    }
  }
}
